export enum WorkflowAlertStatus {
  open = 0,
  closed = 1,
}
